import { fontStyles } from '@/components/pdf/styles';
import { PurchaseOrderBundle } from '@/services/api/contracts/catalog/bundles';
import { getDescriptionFromRichTextArea, isRichTextAreaEmpty } from '@/utils/richText';
import { Text, View } from '@react-pdf/renderer';
import { format } from 'date-fns';
import { FunctionComponent } from 'react';

interface PurchaseOrderDocumentQuotationProps {
  order: PurchaseOrderBundle;
}

const PurchaseOrderDocumentOrder: FunctionComponent<PurchaseOrderDocumentQuotationProps> = ({ order }) => {
  const showNotes = Boolean(order.notes && !isRichTextAreaEmpty(order.notes.value));

  return (
    <View
      style={{
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Text style={{ fontSize: 24, ...fontStyles.bold, textAlign: 'right', marginRight: 20, marginBottom: 10 }}>
        Order
      </Text>

      <View
        style={{
          flexDirection: 'row',
          fontSize: 12
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 180, fontSize: 12 }}>Title:</Text>
        <Text style={{ ...fontStyles.italic, fontSize: 10 }}>{order.name}</Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: 12
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 180, fontSize: 12 }}>Order Date:</Text>
        <Text style={{ ...fontStyles.italic, fontSize: 10 }}>
          {format(new Date(order.submittedOn), 'MMMM do yyyy')}
        </Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: 12
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 180, fontSize: 12 }}>PO Ref:</Text>
        <Text style={{ ...fontStyles.italic, fontSize: 10 }}>{order.poReference}</Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: 12
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 180, fontSize: 12 }}>SO Ref:</Text>
        <Text style={{ ...fontStyles.italic, fontSize: 10 }}>{order.stockingOrderNumber}</Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: 12
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 180, fontSize: 12 }}>Partner Ref:</Text>
        <Text style={{ ...fontStyles.italic, fontSize: 10 }}>{order.partnerReference}</Text>
      </View>
      {showNotes && (
        <View
          style={{
            flexDirection: 'row',
            fontSize: 12
          }}
        >
          <Text style={{ ...fontStyles.bold, width: 180, fontSize: 12 }}>Notes / Special Instructions:</Text>
          <Text style={{ ...fontStyles.italic, fontSize: 10, width: 210 }}>
            {getDescriptionFromRichTextArea(order.notes.value)}
          </Text>
        </View>
      )}
    </View>
  );
};

export default PurchaseOrderDocumentOrder;
